import { render, staticRenderFns } from "./RelatorioAssessoresZona.vue?vue&type=template&id=0be9697b&"
import script from "./RelatorioAssessoresZona.vue?vue&type=script&lang=js&"
export * from "./RelatorioAssessoresZona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports